'use strict';

/*global app*/
/*global btUnknown*/
/*global btArticle*/
/*global btLocation*/
/*global btHandlingUnit*/
/*global btJobCard*/
/*global invokeCallback*/
/*global resSuccess*/
/*global resError*/

function BarcodeService() {
  this.$container = null;

  this.cache = {};

  this.init();
}

BarcodeService.prototype = $.extend({}, {
  constructor: 'BarcodeService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  saveToCache: function saveToCache(barcode, data) {
    var _this = this;

    barcode = barcode.toLowerCase();

    _this.cache[barcode] = data;

    return _this;
  },

  getFromCache: function getFromCache(barcode) {
    var _this = this;

    barcode = barcode.toLowerCase();

    if (barcode in _this.cache) {
      return _this.cache[barcode];
    }

    return null;
  },

  doFind: function doFind(action, data, callback) {
    var _this = this;

    var barcode = data.Barcode;

    var cacheData = _this.getFromCache(barcode);
    if (cacheData) {
      invokeCallback(callback, resSuccess, cacheData);
    } else {
      app.getFormation(action, data, function (res) {
        if (res.msg === 'SUCCESS') {
          if (res.data.BarcodeType !== btUnknown) {
            _this.saveToCache(barcode, res.data);
          }

          invokeCallback(callback, resSuccess, res.data);
        } else {
          app.viewErrorMessage(res.error);
        }
      });
    }

    return _this;
  },

  find: function find(barcode, param, callback) {
    var _this = this;

    return _this.doFind('barcode:find', { Barcode: barcode, Param: param }, callback);
  },

  findArticle: function findArticle(barcode, tradingPartnerId, callback) {
    var _this = this;

    return _this.doFind('barcode:find_article', { Barcode: barcode, TradingPartnerId: tradingPartnerId }, function (res, resData) {
      if (resData.BarcodeType === btArticle) {
        invokeCallback(callback, res, resData);
      } else {
        invokeCallback(callback, resError);
      }
    });
  },

  findLocation: function findLocation(barcode, warehouseId, callback) {
    var _this = this;

    return _this.doFind('barcode:find_location', { Barcode: barcode, WarehouseId: warehouseId }, function (res, resData) {
      if (resData.BarcodeType === btLocation) {
        invokeCallback(callback, res, resData);
      } else {
        invokeCallback(callback, resError);
      }
    });
  },

  findHandlingUnit: function findHandlingUnit(barcode, handlingUnitTypeRID, callback) {
    var _this = this;

    return _this.doFind('barcode:find_handling_unit', { Barcode: barcode, HandlingUnitTypeRID: handlingUnitTypeRID }, function (res, resData) {
      if (resData.BarcodeType === btHandlingUnit) {
        invokeCallback(callback, res, resData);
      } else {
        invokeCallback(callback, resError);
      }
    });
  },

  findJobCard: function findJobCard(barcode, callback) {
    var _this = this;

    return _this.doFind('barcode:find_job_card', { Barcode: barcode }, function (res, resData) {
      if (resData.BarcodeType === btJobCard) {
        invokeCallback(callback, res, resData);
      } else {
        invokeCallback(callback, resError);
      }
    });
  },

  scanBarcode: function scanBarcode(data, callback) {
    var _this = this;

    app.getValueWithRes(data, callback);

    return _this;
  },

  scanAndFind: function scanAndFind(data, param, callback) {
    var _this = this;

    _this.scanBarcode(data, function (res, barcode) {
      if (res !== resSuccess) {
        return invokeCallback(callback, res);
      }

      _this.find(barcode, param, callback);
    });

    return _this;
  },

  scanAndFindBarcode: function scanAndFindBarcode(type, data, param, callback) {
    var _this = this;

    if (!('content' in data)) {
      switch (type) {
        case btArticle: data.content = app.t('barcode.scan_article'); break;
        case btLocation: data.content = app.t('barcode.scan_location'); break;
        case btHandlingUnit: data.content = app.t('barcode.scan_handling_unit'); break;
        case btJobCard: data.content = app.t('barcode.scan_job_card'); break;
      }
    }

    _this.scanBarcode(data, function (res, barcode) {
      if (res !== resSuccess) {
        return invokeCallback(callback, res);
      }

      switch (type) {
        case btArticle : {
          _this.findArticle(barcode, param, callback);
        }

        break;
        case btLocation : {
          _this.findLocation(barcode, param, callback);
        }

        break;
        case btHandlingUnit : {
          _this.findHandlingUnit(barcode, param, callback);
        }

        break;
        case btJobCard : {
          _this.findJobCard(barcode, callback);
        }

        break;
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container = $('body');

    _this.registerCallbacks();

    return _this;
  }
});
